import { PreferenceType } from './../../models/enum/preferenceType';
import { takeUntil } from 'rxjs/operators';
import { PreferencesService } from './../../../avisDePub/preferences-avis-de-pub/services/preferences.service';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { PreferenceMessages } from './../../models/component-messages/preference-messages';
import { Preference } from './../../../avisDePub/preferences-avis-de-pub/model/preference';
import { Observable, Subject } from 'rxjs';
import { NgbModal, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Component, OnInit, Output, EventEmitter, OnDestroy, Input } from '@angular/core';

@Component({
  selector: 'app-select-preference',
  templateUrl: './select-preference.component.html',
  styleUrls: ['./select-preference.component.scss']
})
export class SelectPreferenceComponent implements OnInit, OnDestroy {

  public preferenceMessages = new PreferenceMessages();

  public form: FormGroup;

  @Input() preferenceType: PreferenceType;
  @Output() preferenceSelected = new EventEmitter<Preference>();

  optionsSelect: Preference[];
  public onClose: boolean;

  private unsubscribe$ = new Subject<void>();

  constructor(private ngbActiveModal :NgbActiveModal , private preferenceService: PreferencesService, private fb: FormBuilder) {
  }

  ngOnInit() {
    this.chargePreference();
    this.form = this.fb.group({
      preferenceSelected: [null, Validators.required]
    });
  }

  ngOnDestroy() {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  close() {
    this.ngbActiveModal.close(this.onClose);
  }

  chargePreference() {
    this.optionsSelect = [];
    switch (this.preferenceType) {
      case PreferenceType.FACTURATION:
        this.preferenceService.getlightFacturation()
          .pipe(takeUntil(this.unsubscribe$))
          .subscribe({
            next: ((data) => {
              this.optionsSelect = data;
            })
          });
        break;

      case PreferenceType.DIFFUSEURS:
        this.preferenceService.getlightDiffuseur()
          .pipe(takeUntil(this.unsubscribe$))
          .subscribe({
            next: ((data) => {
              this.optionsSelect = data;
            })
          });
        break;

      case PreferenceType.CODES_CPV:
        this.preferenceService.getlightCpv()
          .pipe(takeUntil(this.unsubscribe$))
          .subscribe({
            next: ((data) => {
              this.optionsSelect = data;
            })
          });
        break;

        case PreferenceType.ACHETEUR:
          this.preferenceService.getlightAcheteur()
            .pipe(takeUntil(this.unsubscribe$))
            .subscribe({
              next: ((data) => {
                this.optionsSelect = data;
              })
            });
          break;

      default:
        break;
    }
  }

  valider() {
    switch (this.preferenceType) {
      case PreferenceType.FACTURATION:
        this.preferenceService.getByIdFacturation(this.form.get("preferenceSelected")?.value)
          .pipe(takeUntil(this.unsubscribe$))
          .subscribe({
            next: ((data) => {
              this.preferenceSelected.emit(data);
              this.exitModal(true);
            })
          });
        break;

      case PreferenceType.DIFFUSEURS:
        this.preferenceService.getByIdDiffuseur(this.form.get("preferenceSelected")?.value)
          .pipe(takeUntil(this.unsubscribe$))
          .subscribe({
            next: ((data) => {
              this.preferenceSelected.emit(data);
              this.exitModal(true);
            })
          });
        break;

      case PreferenceType.CODES_CPV:
        this.preferenceService.getByIdCpv(this.form.get("preferenceSelected")?.value)
          .pipe(takeUntil(this.unsubscribe$))
          .subscribe({
            next: ((data) => {
              this.preferenceSelected.emit(data);
              this.exitModal(true);
            })
          });
        break;

        case PreferenceType.ACHETEUR:
          this.preferenceService.getByIdAcheteur(this.form.get("preferenceSelected")?.value)
            .pipe(takeUntil(this.unsubscribe$))
            .subscribe({
              next: ((data) => {
                this.preferenceSelected.emit(data);
                this.exitModal(true);
              })
            });
          break;

      default:
        break;
    }
  }

  exitModal(bool: boolean) {
    this.onClose = bool;
    this.close();
  }

}
